import L from "leaflet";

class Ico {
  constructor(ico) {
    this.iconUrl = ico;
    this.iconRetinaUrl = ico;
    this.iconAnchor = null;
    this.popupAnchor = new L.Point(0, 0);
    this.shadowUrl = null;
    this.shadowSize = null;
    this.shadowAnchor = null;
    this.iconSize = new L.Point(30, 30);
  }
}

const IUP_L1 = require("../../assets/img/icons/IUP_L1.svg");
const IUP_L2 = require("../../assets/img/icons/IUP_L2.svg");
const IUP_L3 = require("../../assets/img/icons/IUP_L3.svg");
const IUP_L4 = require("../../assets/img/icons/IUP_L4.svg");
export const inclinometerL1Icon = new L.Icon(new Ico(IUP_L1));
export const inclinometerL2Icon = new L.Icon(new Ico(IUP_L2));
export const inclinometerL3Icon = new L.Icon(new Ico(IUP_L3));
export const inclinometerL4Icon = new L.Icon(new Ico(IUP_L4));

const IUP_nieakt = require("../../assets/img/icons/IUP_nieakt.svg");
const IUP_niespar = require("../../assets/img/icons/IUP_niespar.svg");
const IUP_ok = require("../../assets/img/icons/IUP_ok.svg");
const IUP_wyl = require("../../assets/img/icons/IUP_wyl.svg");
export const inclinometerNotActiveIcon = new L.Icon(new Ico(IUP_nieakt));
export const inclinometerNotParameterizedIcon = new L.Icon(new Ico(IUP_niespar));
export const inclinometerOKIcon = new L.Icon(new Ico(IUP_ok));
export const inclinometerNotOperationalIcon = new L.Icon(new Ico(IUP_wyl));

const IUP_L0_obstr = require("../../assets/img/icons/IUP_zast_L0.svg");
const IUP_L1_obstr = require("../../assets/img/icons/IUP_zast_L1.svg");
const IUP_L2_obstr = require("../../assets/img/icons/IUP_zast_L2.svg");
const IUP_L3_obstr = require("../../assets/img/icons/IUP_zast_L3.svg");
const IUP_L4_obstr = require("../../assets/img/icons/IUP_zast_L4.svg");
export const inclinometerL0ObstructedIcon = new L.Icon(new Ico(IUP_L0_obstr));
export const inclinometerL1ObstructedIcon = new L.Icon(new Ico(IUP_L1_obstr));
export const inclinometerL2ObstructedIcon = new L.Icon(new Ico(IUP_L2_obstr));
export const inclinometerL3ObstructedIcon = new L.Icon(new Ico(IUP_L3_obstr));
export const inclinometerL4ObstructedIcon = new L.Icon(new Ico(IUP_L4_obstr));

const UP_L1 = require("../../assets/img/icons/UP_L1.svg");
const UP_L2 = require("../../assets/img/icons/UP_L2.svg");
const UP_L3 = require("../../assets/img/icons/UP_L3.svg");
const UP_L4 = require("../../assets/img/icons/UP_L4.svg");
export const laserL1Icon = new L.Icon(new Ico(UP_L1));
export const laserL2Icon = new L.Icon(new Ico(UP_L2));
export const laserL3Icon = new L.Icon(new Ico(UP_L3));
export const laserL4Icon = new L.Icon(new Ico(UP_L4));

const UP_nieakt = require("../../assets/img/icons/UP_nieakt.svg");
const UP_niespar = require("../../assets/img/icons/UP_niespar.svg");
const UP_ok = require("../../assets/img/icons/UP_ok.svg");
const UP_wyl = require("../../assets/img/icons/UP_wyl.svg");
const UP_ok_zast1 = require("../../assets/img/icons/UP_ok_zast1.svg");
export const laserNotActiveIcon = new L.Icon(new Ico(UP_nieakt));
export const laserNotParameterizedIcon = new L.Icon(new Ico(UP_niespar));
export const laserOKIcon = new L.Icon(new Ico(UP_ok));
export const laserNotOperationalIcon = new L.Icon(new Ico(UP_wyl));
export const laserObstructedIcon = new L.Icon(new Ico(UP_ok_zast1));

const LUP_L0_obstr = require("../../assets/img/icons/LUP_zast_L0.svg");
const LUP_L1_obstr = require("../../assets/img/icons/LUP_zast_L1.svg");
const LUP_L2_obstr = require("../../assets/img/icons/LUP_zast_L2.svg");
const LUP_L3_obstr = require("../../assets/img/icons/LUP_zast_L3.svg");
const LUP_L4_obstr = require("../../assets/img/icons/LUP_zast_L4.svg");
export const laserL0ObstructedIcon = new L.Icon(new Ico(LUP_L0_obstr));
export const laserL1ObstructedIcon = new L.Icon(new Ico(LUP_L1_obstr));
export const laserL2ObstructedIcon = new L.Icon(new Ico(LUP_L2_obstr));
export const laserL3ObstructedIcon = new L.Icon(new Ico(LUP_L3_obstr));
export const laserL4ObstructedIcon = new L.Icon(new Ico(LUP_L4_obstr));

const U_dziala = require("../../assets/img/icons/U_dziala.svg");
const U_nieakt = require("../../assets/img/icons/U_nieakt.svg");
const U_wyl = require("../../assets/img/icons/U_wyl.svg");
export const infrastructureOKIcon = new L.Icon(new Ico(U_dziala));
export const infrastructureNotActiveIcon = new L.Icon(new Ico(U_nieakt));
export const infrastructureNotOperationalIcon = new L.Icon(new Ico(U_wyl));